import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/code.tsx
var Code = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M9.75 20.2501L14.25 3.75006M18.25 7.75006L20.9599 10.6293C21.6847 11.3994 21.6847 12.6007 20.9599 13.3708L18.25 16.2501M5.75 16.2501L3.0401 13.3708C2.3153 12.6007 2.3153 11.3995 3.0401 10.6293L5.75 7.75006",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.4465 3.02643C14.846 3.13542 15.0815 3.54772 14.9726 3.94734L10.4741 20.4473C10.3651 20.847 9.95298 21.0826 9.5535 20.9736C9.15402 20.8646 8.91849 20.4523 9.02744 20.0527L13.5259 3.55267C13.6349 3.15305 14.047 2.91745 14.4465 3.02643ZM6.26598 7.20385C6.56751 7.48774 6.58189 7.9624 6.2981 8.26403L3.58912 11.1433C3.13628 11.6246 3.13628 12.3754 3.58912 12.8567L6.2981 15.736C6.58189 16.0376 6.56751 16.5123 6.26598 16.7962C5.96446 17.08 5.48996 17.0657 5.20617 16.764L2.4972 13.8848C1.50094 12.8259 1.50093 11.1742 2.49719 10.1153L5.20617 7.23598C5.48996 6.93435 5.96445 6.91997 6.26598 7.20385ZM17.734 7.20385C18.0355 6.91997 18.51 6.93435 18.7938 7.23598L21.5028 10.1153C22.4991 11.1742 22.4991 12.8259 21.5028 13.8848L18.7938 16.764C18.51 17.0657 18.0355 17.08 17.734 16.7962C17.4325 16.5123 17.4181 16.0376 17.7019 15.736L20.4109 12.8567C20.8637 12.3754 20.8637 11.6246 20.4109 11.1433L17.7019 8.26403C17.4181 7.9624 17.4325 7.48774 17.734 7.20385Z",
		fill: "currentColor"
	})
});
//#endregion
export { Code };
